declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export const initializeGTM = (): void => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
  }
};

export const trackPageView = (url: string): void => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "pageView",
      page: url,
      page_title: document.title,
      page_location: window.location.href,
      page_path: url,
      gtm: "new_page_view",
    });
  }
};

/**
 * Tracks a custom event with strict typing
 */
// export const trackEvent = <T extends Record<string, unknown>>(
//   eventName: string,
//   eventData?: T
// ): void => {
//   if (typeof window !== 'undefined') {
//     window.dataLayer.push({
//       event: eventName,
//       ...(eventData || {}) // Safe spread
//     });
//   }
// };
